const INSTAGRAM_DOMAIN = /instagram\.com/i;
const INSTAGRAM_PROFILE_URL = /^https?:\/\/(?:www\.)?instagram\.com\/([a-zA-Z0-9._]+)\/?(?:\?.*)?$/i;

const YOUTUBE_DOMAIN = /youtube\.com|youtu\.be/i;
// Channel URLs are often copied straight off a tab (e.g. .../@handle/videos,
// /shorts, /posts) rather than the bare profile page — that trailing tab
// segment is still the same channel, so it's optional here rather than
// treated as a different (rejected) path shape.
const YOUTUBE_PROFILE_URL = /^https?:\/\/(?:www\.)?(?:youtube\.com\/(?:channel\/|c\/|@)|youtu\.be\/)([a-zA-Z0-9._-]+)(?:\/(?:videos|shorts|streams|playlists|community|channels|about|posts))?\/?(?:\?.*)?$/i;

export const parseProfilesInput = (text, platform = "instagram") => {
  if (!text?.trim()) return [];

  const domainPattern = platform === "youtube" ? YOUTUBE_DOMAIN : INSTAGRAM_DOMAIN;
  const profilePattern = platform === "youtube" ? YOUTUBE_PROFILE_URL : INSTAGRAM_PROFILE_URL;

  return text
    .split(/[,\n]/)
    .map((raw) => raw.trim())
    .filter(Boolean)
    .map((entry) => {
      if (domainPattern.test(entry)) {
        // Looks like a URL for this platform — only accept it if it's shaped like a
        // plain profile link (exactly one path segment). Anything else (post/reel/
        // explore/suggestion links, e.g. instagram.com/popular/some-slug) isn't a
        // profile, and naively grabbing the first path segment would silently send
        // a garbage "username" to the paid lookup API instead of being rejected here.
        const match = entry.match(profilePattern);
        return match ? match[1] : null;
      }
      return entry.replace(/^@/, "");
    })
    .filter(Boolean)
    // de-dupe, case-insensitive
    .filter(
      (handle, index, all) =>
        all.findIndex((h) => h.toLowerCase() === handle.toLowerCase()) === index
    );
};
